import * as React from "react";
import { History } from "lucide-react";
import { describeCta, CtaTypeDefinitions, CtaTypeGroupDefinitions } from "../ctaTypes";
import { useCTAWizard } from "../CTAWizardContext";

export const CategoryStep: React.FC = () => {
  const { recentQuickPicks, availableGroups, availableTypes, isPlayer, handleSelectRecent, handleSelectGroup } =
    useCTAWizard();

  return (
    <div className="flex flex-col gap-5">
      {recentQuickPicks.length > 0 && (
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wide">
            <History className="size-3.5" />
            Recently Used
          </div>
          <div className="relative -mx-4 overflow-hidden">
            <div className="flex gap-2 overflow-x-auto no-scrollbar px-4">
              {recentQuickPicks.map((recent, index) => (
                <button
                  key={`${recent.type}-${recent.label}-${recent.customLink}-${recent.formId}-${recent.smartLinkId}-${index}`}
                  type="button"
                  onClick={() => handleSelectRecent(recent)}
                  className="flex w-56 shrink-0 items-start gap-3 rounded-lg border border-border p-3 text-left transition-colors hover:border-primary hover:bg-primary/5 cursor-pointer"
                >
                  <div className="mt-0.5 text-primary">{CtaTypeDefinitions[recent.type].icon}</div>
                  <div className="flex flex-col gap-0.5 min-w-0">
                    <div className="text-sm font-semibold text-slate-800 truncate">{recent.label}</div>
                    <div className="text-xs text-muted-foreground truncate">{describeCta(recent, isPlayer)}</div>
                  </div>
                </button>
              ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-4 bg-gradient-to-r from-background to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-4 bg-gradient-to-l from-background to-transparent" />
          </div>
        </div>
      )}

      <div className="flex flex-col gap-2">
        {recentQuickPicks.length > 0 && (
          <div className="text-xs font-bold text-slate-500 uppercase tracking-wide">Or choose a category</div>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {availableGroups.map(group => {
            const groupDefinition = CtaTypeGroupDefinitions[group];
            const typeCount = availableTypes.filter(type => CtaTypeDefinitions[type].group === group).length;
            return (
              <button
                key={group}
                type="button"
                onClick={() => handleSelectGroup(group)}
                className="flex items-start gap-3 rounded-lg border border-border p-3 text-left transition-colors hover:border-primary hover:bg-primary/5 cursor-pointer"
              >
                <div className="mt-0.5 text-primary">{groupDefinition.icon}</div>
                <div className="flex flex-col gap-0.5">
                  <div className="text-sm font-semibold text-slate-800">{group}</div>
                  <div className="text-xs text-muted-foreground">{groupDefinition.description}</div>
                  <div className="text-[11px] text-slate-400 mt-0.5">
                    {typeCount} {typeCount === 1 ? "option" : "options"}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
